var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpressJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1919 100.16H66.3386C68.5786 100.16 70.6879 99.1146 72.0426 97.3306L92.0025 71.072L111.963 97.3306C113.317 99.1119 115.427 100.16 117.667 100.16H120.813L95.3492 66.6666L119.672 34.6666H116.525C114.285 34.6666 112.176 35.712 110.821 37.496L91.9999 62.2586L73.1759 37.4933C71.8212 35.712 69.7119 34.6666 67.4719 34.6666H64.3252L88.6479 66.6666L63.1919 100.16Z",
    fill: "#8EB4C3",
    fillOpacity: 0.56078
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0001 69.3333V61.3333C64.0001 43.5333 48.1468 29.4373 29.7895 32.3946C15.4988 34.696 5.3335 47.6186 5.3335 62.0906V64V69.3333V69.712C5.3335 87.1866 18.0722 101.141 34.3148 101.333C47.8935 101.493 59.3521 92.4159 62.8668 80.0026H60.1255C58.4721 80.0026 56.9735 80.9493 56.2561 82.4373C51.6188 92.0239 40.8188 98.0693 28.9815 95.3493C18.0695 92.8399 10.6668 82.6159 10.6668 71.4213V69.3333H64.0001ZM10.6668 63.2266C10.6668 50.672 18.1442 40.408 29.1308 37.952C44.7948 34.4533 58.6668 46.272 58.6668 61.3333V64H10.6668V63.2266Z",
    fill: "#8EB4C3",
    fillOpacity: 0.56078
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressJs);
export default __webpack_public_path__ + "static/media/express-js.fc610364143724b5261486ca076912a1.svg";
export { ForwardRef as ReactComponent };